<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()" [strong]="true" data-cy="betslip-close">X</ion-button>
    </ion-buttons>
    <ion-title class="tw-text-center" data-cy="betslip-title">MY BETS</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="bet-modal-container ion-padding">
  <div class="active-ended-row tw-flex">

    <div (click)="savedTab()"
      class="content active-bets tw-text-center">
      <p class="title tw-text-[17px] tw-font-bold tw-uppercase" data-cy="betslip-saved-tab">Saved</p>
      <div
        [ngClass]="{
          'active': showSavedBets
        }"
        class="tab"
      >
      </div>
    </div>

    <div (click)="activeTab()"
      class="content active-bets tw-text-center">
      <p class="title tw-text-[17px] tw-font-bold tw-uppercase" data-cy="betslip-active-tab">Active</p>
      <div
        [ngClass]="{
          'active': showActiveBets
        }"
        class="tab"
      >
      </div>
    </div>

    <div (click)="closedTab()"
      class="content closed-bets tw-text-center">
      <p class="title tw-text-[17px] tw-font-bold tw-uppercase" data-cy="betslip-closed-tab">Closed</p>
      <div
        [ngClass]="{
          'active': showClosedBets
        }"
        class="tab"
      >
      </div>
    </div>
  </div>

  <div *ngIf="showSavedBets && (savedBets$ | async) as bets" class="bet-lists">
    <!-- <div *ngFor="let item of bets | keyvalue"> -->
      <!-- *ngFor="let row of item.value" -->
      <div *ngFor="let row of bets; let i = index" class="bet-row">
        <div class="bet-info" data-cy="saved_betslip-info">
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="race-id tw-uppercase tw-text-[19px] tw-font-bold"
            [attr.data-cy]="'savedbet-race-id-' + i"
          >race {{ row.RaceId }}</span>
          <!-- event name must get in the state: by Michael -->
          <p
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="event-id tw-uppercase tw-text-[14px] tw-font-bold"
            [attr.data-cy]="'savedbet-event-name-' + i">
            {{ getEventName(row.EventId) }}
          </p>
          <!-- event name end -->
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="base-amount tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'savedbet-amount-' + i">
            ${{ row.BaseAmount | number:'1.2' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="pool-id tw-text-[19px] tw-font-bold tw-mx-[5px]"
            [attr.data-cy]="'savedbet-pool-' + i">
            {{ row.PoolId }} {{ row.Modifier !== 'None' ? convertWordsToAbbre(row.Modifier) : '' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="runners-number tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'savedbet-runner-' + i">
            {{ formatConsecutiveStringFE(row.Runners) }}
          </span>
        </div>
        <div class="action tw-text-right">
          <span
            (click)="confirmBet('submit-saved-bet', row)" class="submit-saved-bet tw-uppercase tw-text-[16px]" [attr.data-cy]="'savedbet-submit-' + i">
             submit
          </span>
          <span
            (click)="confirmBet('remove-saved-bet', row)" class="remove-saved-bet tw-uppercase tw-text-[16px]" [attr.data-cy]="'savedbet-remove-' + i">
             remove
          </span>
        </div>
        <br class="tw-clear-both">
        <div class="bet-total-row">
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="bet-total tw-uppercase tw-text-[17px] tw-font-bold">
            bet total: <span class="amount" [attr.data-cy]="'savedbet-bet-total-' + i">$ {{ row.TicketAmount | number:'1.2' }}</span>
          </span>
        </div>
      </div>
      <div class="total-amount tw-uppercase tw-text-[20px] tw-font-bold">
        grand total: <span class="amount" data-cy="savedbet-grand-total">$ {{ getTotalAmount(savedTickets, 1) | number:'1.2' }}</span>
      </div>
    <!-- </div> -->
  </div>

  <div *ngIf="showActiveBets && (activeBets$ | async) as bets" class="bet-lists" data-cy="betslip-lists">
    <!-- <div *ngFor="let item of bets | keyvalue"> -->
      <!-- *ngFor="let row of item.value" -->
      <div *ngFor="let row of bets; let i = index" class="bet-row">
        <div class="bet-info" data-cy="active_betslip-info">
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="race-id tw-uppercase tw-text-[19px] tw-font-bold"
            [attr.data-cy]="'betslip-race-id-' + i">
            race {{ row.RaceId }}</span>
          <!-- event name must get in the state: by Michael -->
          <p
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="event-id tw-uppercase tw-text-[14px] tw-font-bold"
            [attr.data-cy]="'betslip-event-name-' + i">
            {{ getEventName(row.EventId) }}
          </p>
          <!-- event name end -->
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="base-amount tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'betslip-amount-' + i">
            ${{ row.BaseAmount | number:'1.2' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="pool-id tw-text-[19px] tw-font-bold tw-mx-[5px]"
            [attr.data-cy]="'betslip-pool-' + i">
            {{ row.PoolId }} {{ row.Modifier !== 'None' ? convertWordsToAbbre(row.Modifier) : '' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="runners-number tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'betslip-runner-' + i">
            {{ formatConsecutiveStringFE(row.Runners) }}
          </span>
        </div>
        <div class="action tw-text-right">
          <span
            [ngClass]="{
              'tw-text-[#D51B35]': row.IsCancelled
            }"
            (click)="confirmCancelBet(row)" class="cancel-status tw-uppercase tw-text-[16px]" [attr.data-cy]="'betslip-cancel-' + i">
             {{ row.IsCancelled ? 'cancelled' : 'cancel' }}
            <!-- <ion-icon
              name="trash-outline"
              class="trash-icon tw-relative tw-top-[3px] tw-text-[20px]"
            >
            </ion-icon> -->
          </span>
        </div>
        <br class="tw-clear-both">
        <div class="bet-total-row">
          <span [attr.data-cy]="'betslip-bet-total-' + i"
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="bet-total tw-uppercase tw-text-[17px] tw-font-bold">
            bet total: <span class="amount">$ {{ row.TicketAmount | number:'1.2' }}</span>
          </span>
        </div>
      </div>
      <div class="total-amount tw-uppercase tw-text-[20px] tw-font-bold" data-cy="betslip-grand-total">
        grand total: <span class="amount">$ {{ getTotalAmount(activeTickets, 3) | number:'1.2' }}</span>
      </div>
    <!-- </div> -->
  </div>

  <div *ngIf="showClosedBets && (closedBets$ | async) as bets" class="bet-lists">
    <!-- <div *ngFor="let item of bets | keyvalue"> -->
      <!-- *ngFor="let row of item.value" -->
      <div *ngFor="let row of bets; let i = index" class="bet-row">
        <div class="bet-info" data-cy="closed_betslip-info">
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="race-id tw-uppercase tw-text-[19px] tw-font-bold"
            [attr.data-cy]="'betslip-race-id-' + i">
            race {{ row.RaceId }}</span>
          <!-- event name must get in the state: by Michael -->
          <p
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="event-id tw-uppercase tw-text-[14px] tw-font-bold"
            [attr.data-cy]="'betslip-event-name-' + i">
            {{ getEventName(row.EventId) }}
          </p>
          <!-- event name end -->
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="base-amount tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'betslip-amount-' + i">
            ${{ row.BaseAmount | number:'1.2' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="pool-id tw-text-[19px] tw-font-bold tw-mx-[5px]" [attr.data-cy]="'betslip-pool-' + i">
            {{ row.PoolId }} {{ row.Modifier !== 'None' ? convertWordsToAbbre(row.Modifier) : '' }}
          </span>
          <span
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="runners-number tw-text-[17px] tw-font-bold"
            [attr.data-cy]="'betslip-runner-' + i">
            {{ formatConsecutiveStringFE(row.Runners) }}
          </span>
        </div>
        <div class="action tw-text-right">
          <ng-container *ngIf="((row.NetPayoff - row.TicketAmount) > 0) && !row.IsCancelled">
            <span class="pay-net-off tw-text-[17px] tw-font-bold tw-mr-[18px]">
              Pay: ${{ row.NetPayoff | number:'1.2' }}
            </span>
          </ng-container>
        </div>
        <br class="tw-clear-both">
        <div class="bet-total-row">
          <span [attr.data-cy]="'betslip-bet-total-' + i"
            [ngClass]="{
              'tw-line-through': row.IsCancelled
            }"
            class="bet-total tw-uppercase tw-text-[17px] tw-font-bold">
            bet total: <span class="amount">$ {{ row.TicketAmount | number:'1.2' }}</span>
          </span>
        </div>
      </div>
    <!-- </div> -->
  </div>

</ion-content>
